import axios from "axios";

export const isSessionExpired = () => {
  const expiry = localStorage.getItem("sessionExpiry");

  if (!expiry) return false;

  return Date.now() > Number(expiry);
};

export const clearSession = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("sessionExpiry");
};

export const expireSession = () => {
  clearSession();
  localStorage.setItem(
    "sessionExpiredMessage",
    "Session expired, kindly login again."
  );
};

export const config = () => {
  const getTokenFromLocalStorage = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  return {
    headers: {
      Authorization: `Bearer ${
        getTokenFromLocalStorage?.token || ""
      }`,
      Accept: "application/json",
    },
  };
};

axios.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;

    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);